import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import './RolloverDetails.scss';
import {
  SSJBeaconButton,
  SSJBeaconInputField,
} from '../../../Shared/Beacon/Registry';

import { useSelector } from 'react-redux';
import { incrementStep } from '../../../../redux/modules/transferFunding/stepActions';
import { putFundingTrackingData } from '../../../../redux/modules/fundingTrackingData/fundingTrackingData.module';
import { ButtonType } from '../../../Shared/Button';
import useForm from '../../../Shared/hooks/useForm';
import { RolloverConstants } from '../../RolloverConstants';
import { beaconPattern } from '../../../../utils/fundingMethod/fundingMethodUtils';
import AutoCompleteCustodians from '../../../Shared/AutoCompleteCustodians/AutoCompleteCustodians';
import rightArrow from '../../../../assets/images/beacon-chevron-right.svg';
import { dispatchPageLoad } from '../../../../redux/utils/analytics-helper';

const RolloverDetails = () => {
  useEffect(() => {
    dispatchPageLoad('Provide Details');
  }, []);

  const dispatch = useDispatch();
  const fundingTrackingData = useSelector(
    (state) => state?.fundingTrackingData
  );
  const { values, handleSubmit, setValues } = useForm(
    {
      rolloverToFirmName:
        RolloverConstants.rolloverDetailsPage.labels.TrowePrice,
      rolloverToAccountType:
        fundingTrackingData?.store?.userAccountFundingData?.agreementType,
      rolloverToAccountNumber:
        fundingTrackingData?.store?.AccountAgreementNumber || '',
      externalFinancialInstituteName:
        fundingTrackingData?.payload?.onboardingDataStore
          ?.onboardingDatastoreRollover?.externalFinancialInstituteName || '',
      csdId:
        fundingTrackingData?.payload?.onboardingDatastore
          ?.onboardingDatastoreRollover?.csdId || '',
      transferTopInstitution:
        fundingTrackingData?.payload?.onboardingDataStore
          ?.onboardingDatastoreRollover?.transferTopInstitution || false,
      rolloverTopInstitution:
        fundingTrackingData?.payload?.onboardingDataStore
          ?.onboardingDatastoreRollover?.rolloverTopInstitution || false,
      formalEmployerName:
        fundingTrackingData?.payload?.onboardingDataStore
          ?.onboardingDatastoreRollover?.formalEmployerName || '',
    },
    () => {
      if (fundingTrackingData?.payload?.onboardingDataStore) {
        fundingTrackingData.payload.onboardingDataStore.onboardingDatastoreRollover =
          {
            ...fundingTrackingData.payload.onboardingDataStore
              .onboardingDatastoreRollover,
            ...values,
          };
      }
      if (
        fundingTrackingData?.payload?.onboardingDataStore
          ?.onboardingDatastoreRollover?.externalFinancialInstituteName === ''
      ) {
        const instituteEle = document.querySelector('#externalFiName');
        if (instituteEle) {
          instituteEle?.evaluateValidations();
        }
      } else {
        // saving user input into redux store
        dispatch(putFundingTrackingData(fundingTrackingData.payload));
        window.scrollTo(0, 0);
        dispatch(incrementStep());
      }
    }
  );

  /* eslint-disable */
  useEffect(() => {
    setValues({
      ...values,
      rolloverToAccountType:
        fundingTrackingData?.store?.userAccountFundingData?.agreementType || '',
      rolloverToAccountNumber:
        fundingTrackingData?.store?.AccountAgreementNumber || '',
      formalEmployerName:
        fundingTrackingData?.payload?.onboardingDataStore
          ?.onboardingDatastoreRollover?.formalEmployerName || '',
      externalFinancialInstituteName:
        fundingTrackingData?.payload?.onboardingDataStore
          ?.onboardingDatastoreRollover?.externalFinancialInstituteName || '',
    });
  }, [fundingTrackingData?.isLoaded]);

  const RollOverView = () => {
    return (
      <div className="overview-wrapper">
        <div className="title">
          {RolloverConstants.rolloverDetailsPage.pageTitle}{' '}
        </div>
        <div className="description">
          <p className="description_firstp">
            {RolloverConstants.rolloverDetailsPage.p.first}
          </p>
          <p>{RolloverConstants.rolloverDetailsPage.p.second}</p>
        </div>
      </div>
    );
  };

  const RollOverDetails = () => {
    return (
      <div className="details-wrapper">
        <div className="details-wrapper_title">
          {RolloverConstants.rolloverDetailsPage.firstFormTitle}
        </div>
        <div className="table">
          <div className="row">
            <div className="item">
              {RolloverConstants.rolloverDetailsPage.labels.firmName}
            </div>
            <div className="content">
              {RolloverConstants.rolloverDetailsPage.labels.TrowePrice}
            </div>
          </div>
          <div className="line-thin" />
          <div className="row">
            <div className="item">
              {RolloverConstants.rolloverDetailsPage.labels.accountType}
            </div>
            <div className="content">
              {fundingTrackingData?.store?.normalizedAccountType}
            </div>
          </div>
          <div className="line-thin" />
          <div className="row">
            <div className="item">
              {RolloverConstants.rolloverDetailsPage.labels.accountNumber}
            </div>
            <div className="content blocked_data">
              {values.rolloverToAccountNumber}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const handleFormerEmpName = (e) => {
    const empName = e.target.value;
    setValues({
      ...values,
      formalEmployerName: empName,
    });
  };

  return (
    <div id="rollover-details-container" className="rollover-details">
      <RollOverView />
      <RollOverDetails />
      <div className="form-wrapper">
        <div className="rollover-from-title title">Rollover From:</div>
        <div className="form">
          <AutoCompleteCustodians
            values={values}
            setValues={setValues}
            variant="rollover"
          />

          <div className="input-field">
            <SSJBeaconInputField
              id="formalEmployerName"
              name="formalEmployerName"
              label="Former Employer Name"
              hint="Enter the workplace sponsor of the retirement account you're moving."
              value={values?.formalEmployerName}
              required="true"
              format-type="pattern"
              pattern={beaconPattern.employerName}
              onBlur={handleFormerEmpName}
              errors-map='{"required":"You must add the workplace sponsor of the retirement account you&apos;re moving"}'
            />
          </div>

          <SSJBeaconButton
            id="detials-submit-btn"
            className="submit-btn rollover-details-continue-btn"
            icon-align="right"
            label="Continue"
            onClick={handleSubmit}
            buttonType={ButtonType.PRIMARY}
            scale="jumbo"
          >
            <img
              slot="icon"
              icon-align="right"
              alt="Continue Button"
              className="rollover-continue-arrow-icon"
              fill="none"
              height="16"
              width="16"
              src={rightArrow}
            />
          </SSJBeaconButton>
        </div>
      </div>
    </div>
  );
};

export default RolloverDetails;
